import { useFeatureDetailsLanguagesQuery } from "@/v2-backoffice-client/feature/details/feature.details.languages.query"
import { useFeatureDetailsTranslationQuery } from "@/v2-backoffice-client/feature/details/feature.details.featureTranslation.query"
import { toSupportedLanguages } from "@/v2-backoffice-client/translation/translation.board.utils"

type UseFeatureDetailsTextsInput = {
  featureCode: string
}

/**
 * Composes the two catalog lookups behind a catalog sheet's text editor —
 * the supported-language list and the feature's single-feature translation —
 * behind one hook so the consuming component stays at a single query hook.
 */
export function useFeatureDetailsTexts(input: UseFeatureDetailsTextsInput) {
  const { featureCode } = input

  const {
    data: languagesData,
    loading: languagesLoading,
    error: languagesError,
  } = useFeatureDetailsLanguagesQuery()

  const {
    data: translationData,
    loading: translationLoading,
    error: translationError,
    refetch,
  } = useFeatureDetailsTranslationQuery({
    variables: { code: featureCode },
    fetchPolicy: "cache-and-network",
  })

  return {
    languages: toSupportedLanguages(
      languagesData?.getTranslationLanguages ?? [],
    ),
    feature: translationData?.getFeatureTranslation,
    isLoading: languagesLoading || (translationLoading && !translationData),
    // Either read failing leaves the editor with nothing to show; the
    // consumer says so rather than rendering every field empty.
    error: translationError ?? languagesError,
    refetch,
  }
}
